export const logBodyProcessor = (body) => {
    try {
      return JSON.stringify(body);
    } catch (err) {
      console.error("Error stringifying log body:", body);
      return body;
    }
};

export function createLoggerFunction(level) {
    return function(parentFunction, message, body = null) {
      const timestamp = new Date().toISOString();
      let logMsg = `${timestamp} | ${parentFunction} | ${message}`;
      if (body) {
        logMsg += ` | ${typeof body === 'object' ? logBodyProcessor(body) : body}`;
      }
      this.$log[level](logMsg);
    };
};

  
